var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.question_sign)?_c('div',{class:[
        'question',
        _vm.langText,
        {
            pc: _vm.isPc()
        }
    ]},[_c('p',{staticClass:"question-title"},[_vm._v(_vm._s(_vm.baseData.title))]),_vm._v(" "),_c('p',{staticClass:"question-desc"},[_vm._v(_vm._s(_vm.baseData.desc))]),_vm._v(" "),_c('qa-form',{attrs:{"questions":_vm.questions,"questionStatus":_vm.questionStatus,"userAnswer":_vm.userAnswer,"authMode":_vm.authMode,"isPc":_vm.isPc()},on:{"refresh":_vm.getQuestion}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }